import NProgress from 'nprogress';
import qs from 'qs';
import { NioApmPlus } from '@nio-fe/nio-apm-plus';
import { collectLog } from '@/api/client/courtclerkClient';
import {
  getObjectToUrl,
  getUrlParam,
  getMergePath,
  getRouterName,
} from './router';
import useGlobalStore, { IAppStore } from '@/store/globalStore';
import useMatestoreStore, { IMatestoreStore } from '@/store/matestoreStore';
import MicroDialog from '@/components/micro-dialog';
import MicroDrawer from '@/components/micro-drawer';
import MicroDrawerV2 from '@/components/micro-drawer-v2';
import { omit } from 'lodash-es';
import { useRoute, RouteLocationNormalizedLoaded, Router } from 'vue-router';
import type { MicroData } from '@/api/model/globalModel';
import SensorsTracker from '@nio-fe/nio-tracker-web';
import Tracker from '@nio-fe/tracker-sdk';
import {
  IGlobalRouterStore,
  useGlobalRouteStore,
} from '@/store/globalRouteStore';
import { SeverityLevel } from '@sentry/types/types/severity';
import {
  IMicroMessageStoreStore,
  useMicroMessageStore,
} from '@/store/messageStore';
type APMMessageLevel = 'info' | 'warn' | 'error' | 'debug';
interface PayloadMicroData extends MicroData {
  appCode: string;
  pageCode?: string;
  routePath?: string;
  routeHash?: string;
  params?: Record<string, string>;
  isWebNewTab?: boolean;
  width?: string | number;
  checkPage?: boolean;
}

const timeout = (time: number) =>
  new Promise((resolve) => {
    const id = setTimeout(() => {
      resolve(id);
    }, time);
  });
const toRawObject = (obj: any) => {
  if (!obj) {
    return obj;
  }
  if (typeof obj !== 'object') {
    return obj;
  }
  return JSON.parse(JSON.stringify(obj));
};
/**
 * 尽量与workbench一致
 */
export default class MessageHandler {
  router: Router;
  route: RouteLocationNormalizedLoaded;
  matestoreStore: IMatestoreStore;
  messageStore: IMicroMessageStoreStore;
  routerStore: IGlobalRouterStore;
  globalStore: IAppStore;
  // store: any
  openerPage: any[];

  constructor(router: Router) {
    const _this = this;
    this.globalStore = useGlobalStore();
    this.matestoreStore = useMatestoreStore();
    this.routerStore = useGlobalRouteStore();
    this.messageStore = useMicroMessageStore();
    this.route = useRoute();
    this.router = router;
    // this.store = store
    this.openerPage = [];
    const titMicroId = getUrlParam('titMicroId');
    const handle = async (event: MessageEvent) => {
      const __msgId = event.data?.__msgId;
      const type: string = event.data?.type;
      const hasCallback = event.data?.hasCallback;
      const _microId = event.data?.titMicroId;
      // openPage isWebNewTab
      if (type === 'openerLoaded' && titMicroId) {
        const index = this.openerPage.findIndex(
          (item: any) => item.titMicroId === _microId
        );
        const openerData = this.openerPage.splice(index, 1)[0];
        openerData?.win.postMessage({
          type: 'updatePage',
          titMicroId,
          data: toRawObject(openerData.data),
          __msgId: Date.now(),
        });
      }
      // ! 这里需要阻塞基座向子应用回复的消息
      if (!__msgId || `${__msgId}`.startsWith('resp:')) {
        return;
      }
      const processor = (_this as any)[type];
      let code = 0;
      let errormsg: string | null = `Unsupported type: ${type}`;
      let data = null;
      if (processor) {
        data = await processor(event.data?.data || {}, (cbData: any) => {
          if (hasCallback) {
            event.source?.postMessage({
              code,
              data: toRawObject(cbData),
              __msgId: `resp:${__msgId}`,
            });
          }
        });
        code = 1;
        errormsg = null;
      } else {
        // ! 回复的消息，需要增加前缀，需要和子应用的消息id有区分度，否则子应用会把自己的消息当成回复的消息
        code = 0;
        errormsg = `Unsupported type: ${type}`;
      }

      !hasCallback &&
        event.source?.postMessage({
          code,
          data: toRawObject(data),
          __msgId: `resp:${__msgId}`,
          errormsg,
        });
    };
    window.addEventListener('message', handle);
    // openPage isWebNewTab 打开web tab判断打开页面是否加载完成
    const opener = window.opener;
    if (opener) {
      opener.postMessage({
        type: 'openerLoaded',
        titMicroId,
      });
    }
  }

  initTitanInfo = () => {
    return {
      appId: this.globalStore.userInfo.appId,
      env: this.globalStore.userInfo.env,
      lang: this.globalStore.global.lang,
      region: this.globalStore.global.region,
      administrator: this.globalStore.getBrandAdministrator(),
      token: this.globalStore.global.accessToken,
      userInfo: this.globalStore.userInfo,
    };
  };

  openPage = async (payload: PayloadMicroData | string) => {
    console.log('openPage payload', payload);
    let distPayload: PayloadMicroData;
    const generatePayloadFromRoutePath = (routePath) => {
      const route = this.routerStore.parsePath(routePath);
      const microData = this.matestoreStore.microMap[route.name as string];
      if (!microData) {
        throw new Error('未找到该页面');
      }
      return {
        appCode: microData.appCode,
        pageCode: microData.pageCode,
        routeHash: route.hash,
        query: route.query,
      };
    };

    if (
      typeof payload === 'object' &&
      !payload.appCode &&
      !!payload.routePath
    ) {
      distPayload = {
        ...payload,
        ...generatePayloadFromRoutePath(payload.routePath),
      };
    }
    MicroDrawer.close();
    if (typeof payload === 'string') {
      if (/http(s)?:\/\//.test(payload)) {
        const url = new URL(payload);
        const entry = `${url.origin}${url.pathname}`;
        const microApp = this.matestoreStore.findMicroAppByEntry(entry);
        /*TODO：这里的判断有问题*/

        if (microApp) {
          // @ts-ignore
          distPayload = {
            appCode: microApp.appCode,
            pageCode: microApp.pageCode,
            routeHash: url.hash,
            // @ts-ignore
            query: qs.parse((url.search || '').replace(/^\?/, '')),
          };
        } else {
          window.open(payload, '_blank');
          return;
        }
      } else {
        //@ts-ignore
        distPayload = generatePayloadFromRoutePath(payload);
      }
    } else {
      distPayload = payload;
    }
    const {
      appCode,
      pageCode,
      routePath,
      routeHash,
      query,
      params,
      title,
      icon,
      isWebNewTab,
      width,
    } = distPayload;
    const name = getRouterName({ appCode, pageCode });
    if (['message', 'im'].includes(name)) {
      this.matestoreStore.openImMicro();
      if (params) {
        const openMessageCallback = () => {
          this.globalStore.hideFullScreenLoading(300);
        };
        let isFirstLoad = false;
        if (!this.matestoreStore.findMicroApp('im')?._microAppInfo) {
          await this.matestoreStore.loadImMicro(
            document.getElementById('im-frame-viewport') as HTMLElement
          );
          isFirstLoad = true;
        }
        await this.matestoreStore.findMicroApp('im')?.isIsLoadedPromise;
        if (isFirstLoad) {
          await timeout(500);
        }

        if (params.groupId) {
          this.globalStore.showFullScreenLoading(10 * 1000);
          noticeMicro(
            'im',
            {
              action: 'openGroup',
              groupId: params.groupId,
              brand: params.brand || 'nio',
            },
            openMessageCallback
          );
        } else if (params.accountId) {
          this.globalStore.showFullScreenLoading(10 * 1000);
          noticeMicro(
            'im',
            {
              action: 'openSingle',
              accountId: params.accountId,
              brand: params.brand || 'nio',
            },
            openMessageCallback
          );
        }
      }
      return;
    }

    // @ts-ignore
    const path = getMergePath([appCode, pageCode, routePath], query);
    const microData = this.matestoreStore.microMap[name];
    if (!microData) {
      return Promise.reject('未找到该页面');
    }
    // 子应用 hash，参数拼url
    let hash = routeHash || distPayload.hash || microData.hash;
    /*TODO: 这里设计非常奇怪，需要重构*/
    if (params) {
      if (hash) {
        /*TODO: 需要考虑hash本身带params 同时又有params参数的场景*/
        hash = hash + getObjectToUrl(params, '?');
      }
    }
    // if (!microData?.multiple) {
    //   query.triggered_openpage_without_multiple = 1;
    // }
    /*TODO: should not use this one*/
    if (isWebNewTab) {
      const win = window.open(path + `#${hash || '/'}`);
      this.openerPage.push({
        win,
        data: { ...distPayload },
      });
    } else {
      const destHash = /^#/.test(hash as string) ? hash : `#${hash}`;
      const routeContent = {
        path,
        hash: destHash as string,
        query,
        params: {
          title,
          icon,
          name,
          width,
        },
      };
      /*这里改成切换hash*/
      const routerStore = useGlobalRouteStore();
      routerStore.push(routeContent);
      console.log('openPage route =>', routeContent);
      // @ts-ignore
      this.matestoreStore.addMicroTabItem({
        ...routeContent,
        microName: name,
      });
    }
  };

  /**
   * TODO
   * @param {*} payload
   */
  updatePage = (payload: PayloadMicroData) => {
    console.log('updatePage payload', payload);
    const { appCode, pageCode, routePath } = payload;
    // if (payload.path) console.warn('path冲突, 会被覆盖');
    this.matestoreStore.updateMicro(getRouterName({ appCode, pageCode }), {
      ...payload,
    });
  };

  closeAllTabs = () => {
    // this.store.dispatch('router/removeMatestoreTabsAll')
  };

  getAllTabs = () => {
    // return this.store.state['router/menusRoutes']
  };

  getAllMenus = () => {
    console.warn('Titan getAllMenus Disabled');
    return [];
  };

  logout = () => {
    // return this.store.dispatch('app/logout')
  };

  refresh = () => {
    console.warn('Titan refresh Disabled');
  };

  showLoading = () => {
    NProgress.done();
  };

  hideLoading = () => {
    NProgress.done();
  };

  getCurrentUser = () => {
    return this.globalStore.getUserInfo;
  };

  /**
   * @deprecated
   */
  getPermission = () => {
    return this.globalStore.getBrandAdministrator();
  };

  getAdministrator = ({ brand = 'nio' }: { brand: string | string[] }) => {
    if (Array.isArray(brand)) {
      return brand.map((i) => this.globalStore.getBrandAdministrator(i));
    }
    return this.globalStore.getBrandAdministrator(brand);
  };

  getAuthorityMapping = ({ brand = 'nio' }: { brand: string | string[] }) => {
    if (Array.isArray(brand)) {
      return brand.map((i) => this.globalStore.getBrandAuthorityMapping(i));
    }
    return this.globalStore.getBrandAuthorityMapping(brand);
  };

  setMenuBadge = (data: PayloadMicroData) => {
    return this.setRouterMeta(data);
  };

  setRouterMeta = (data: PayloadMicroData) => {
    const name = getRouterName(data);
    return this.matestoreStore.updateMicro(name, { ...data });
  };

  openSearch = () => {
    MicroDialog.open({ appName: 'search/appSearch' });
  };

  getTabs = (options: {
    appCode?: string;
    pageCode?: string;
    appName?: string;
  }) => {
    const { appCode, pageCode, appName } = options;
    const name = getRouterName({ appCode, pageCode, name: appName });
    if (!name) {
      return [];
    }
    return this.matestoreStore.microTabMapping[name];
  };

  closeTab = (options: {
    appCode?: string;
    pageCode?: string;
    appName?: string;
    tabIndex: number;
  }) => {
    const { appCode, pageCode, appName } = options;
    const name = getRouterName({ appCode, pageCode, name: appName });
    if (!name) {
      console.warn('micro app name', name, ' is undefined');
      return;
    }
    this.matestoreStore.removeTabItem(name, options.tabIndex);
  };

  /*@TODO: 这里写的有问题*/
  openUserInfo = (userID: string) => {
    MicroDrawer.open({ appName: 'sales/appUserDetail', params: { userID } });
  };

  closeUserInfo = () => {
    MicroDrawer.close();
  };

  openDrawer = (options: {
    appName?: string;
    appCode?: string;
    pageCode?: string;
    params: Record<string, string>;
    path?: string;
    drawerProps?: Record<string, any>;
    openAsIframe?: boolean;
    version?: number;
  }) => {
    if (!options.version) {
      MicroDrawer.open(options);
    } else {
      MicroDrawerV2.open(options);
    }
  };

  closeDrawer = () => {
    MicroDrawer.close();
  };

  unfoldDrawer = () => {
    MicroDrawer.unfold();
  };

  foldDrawer = () => {
    MicroDrawer.fold();
  };

  openDialog = (options: {
    appName: string;
    params: Record<string, string>;
  }) => {
    const { appName, params } = options;
    MicroDialog.open({ appName, params });
  };

  showOverloadingMask = ({ microName }: { microName?: string }) => {
    if (!microName) {
      const micro = this.matestoreStore.currentApp;
      if (!micro) {
        return;
      }
      microName = micro.name as string;
    }
    this.matestoreStore.showOverloadingMask(microName);
  };

  hideOverloadingMask = ({ microName }: { microName?: string }) => {
    this.matestoreStore.hideOverloadingMask();
  };

  closeDialog = (accId: string) => {
    // const { appName, params } = options
    MicroDialog.close(accId);
  };

  getDrawerVisible = () => {
    return MicroDrawer.getVisible();
  };

  setMicroMessage = (options: { appName: string; key: string; data: any }) => {
    const { appName, key, data } = options;
    this.messageStore.setMessageData(appName, key, data);
  };

  resetMicroMessage = (options: { appName: string }) => {
    this.messageStore.resetMessageData(options.appName);
  };

  /**
   * @deprecated
   */
  sentryCaptureMessage = ({
    appName,
    message,
    level = 'error',
  }: {
    appName: string;
    message: string;
    level: SeverityLevel;
  }) => {
    // return withScope((scope) => {
    //   scope.setExtra('appName', appName);
    //   captureMessage(message, level);
    // });
    const levelMap = {
      fatal: 'error',
      log: 'info',
      warning: 'warn',
      debug: 'debug',
      error: 'error',
      info: 'info',
    };
    if (!levelMap[level]) {
      level = 'error';
    }
    return this.apmCaptureMessage(
      appName,
      message,
      levelMap[level] as APMMessageLevel
    );
  };

  apmCaptureMessage = (
    appName: string,
    message: string,
    level: 'info' | 'warn' | 'error' | 'debug',
    extra: Record<string, any> = {}
  ) => {
    const instance = NioApmPlus.getDefaultInstance();
    if (!instance || !instance[level]) {
      return;
    }
    instance?.[level](message, { appName, ...extra });
  };

  /**
   * 日志
   * @param {*} options
   */
  collectLog = (options: Record<string, string | number>) => {
    const accountId =
      this.globalStore.userInfo.domainAccount ||
      this.globalStore.userInfo.accountId;
    const project = this.globalStore.userInfo.appId;
    try {
      collectLog({
        account_id: accountId,
        project,
        module: options.appCode,
        ...options,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 埋点
   * @param {*} options
   */
  sensorsTrack = (options) => {
    const micro = this.matestoreStore.findMicroApp(options.minip_id);
    const t = Tracker;
    console.log(
      `micro app => ${options.minip_id} use nio tracker`,
      micro?.useNioTracker
    );
    t.track(options.trackName, {
      mp_id: options.minip_id,
      ...omit(options, 'trackName'),
    });
  };
}
export const noticeMicro = (
  appCode: string,
  data: Record<string, any>,
  callback?: (res: any) => void
) => {
  const __noticeId = Date.now();
  console.log('titanNotice', appCode, data);
  let win: Window = window;
  if (window.__MATE_APP_OPTIONS?.iframeMode) {
    win = window.parent;
  }
  win.postMessage({
    type: 'titanNotice',
    appCode,
    data,
    __noticeId,
  });
  if (callback) {
    let isRemove = false;
    const handler = (resp: any) => {
      if (
        resp &&
        resp.data &&
        resp.data.__noticeId &&
        resp.data.__noticeId === `noticeResp:${__noticeId}`
      ) {
        callback(resp.data);
        win.removeEventListener('message', handler, false);
        isRemove = true;
      }
    };
    win.addEventListener('message', handler, false);
    setTimeout(() => {
      !isRemove && win.removeEventListener('message', handler, false);
    }, 10000);
  }
};
